























































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import urlHelper from '@/core/urlHelper.service';
import { pages } from './paging.service';
import Bus from '@/core/bus/Bus.vue';
import { RawLocation } from 'vue-router';
@Component({
    components: { Bus }
})
export default class PagingCtrl extends Vue {
    private pages: number[] = [];
    currentPage = 1;

    @Prop({ type: Number, default: 0 })
    private totalResults!: number;

    @Prop({ type: Number, default: 0 })
    private pageSize!: number;

    @Prop({ type: Number, default: 0 })
    private lastPage!: number;

    @Prop({ type: Boolean, default: false })
    private searching!: boolean;

    created() {
        this.setup();
    }

    @Watch('searching')
    private onSearchingChange(value: boolean) {
        if (!value) {
            this.setup();
        }
    }

    private setup() {
        this.currentPage = this.normalizePageNo(urlHelper.getPage());
        this.pages = pages(this.currentPage, this.lastPageComputed);

        // For now remove the last page (if dots just before) because BE runs into elastic problems when many pages. Devops #2314.
        if (this.pages[this.pages.length - 2] === -1) {
            this.pages.pop();
        }
    }

    // Legacy support for last page not being provided by the server
    get lastPageComputed(): number {
        return this.lastPage || Math.ceil(this.totalResults / this.pageSize);
    }

    private goto(page): void {
        this.currentPage = page;
        urlHelper.setPage(page);
    }

    private get goBackEnabled(): boolean {
        return this.currentPage > 1;
    }

    private get goForwardEnabled(): boolean {
        return this.currentPage < this.lastPageComputed;
    }

    private pageLink(page: number): RawLocation {
        page = this.normalizePageNo(page);
        return urlHelper.getLocationForPage(page);
    }

    private normalizePageNo(page: number): number {
        // Make sure user has not typed crazy value into url
        return Math.min(Math.max(page, 1), this.lastPageComputed);
    }

    private get seoOnlyPagination(): number[] {
        const numberOfLinksToPrint = 10;
        const maxPage = this.currentPage + numberOfLinksToPrint;
        const seoMaxPage = Math.min(maxPage, this.lastPage);
        return Array.from({ length: (seoMaxPage) - (this.currentPage) }, (_, i) => i + this.currentPage + 1);
    }
}
